<template>
    <page>
        <module :title="id ? '编辑预售活动' : '新建预售活动'">
            <c-form ref="form" unit-width="500">
				<c-title>基础信息</c-title>
				<c-form-item label="活动名称" required>
					<c-input name="activity_name" placeholder="请输入活动名称" maxlength="20"></c-input>
					<c-input name="activity_id" type="hidden" v-model="activity_id" ></c-input>
				</c-form-item>
				<c-form-item label="活动时间" required>
					<c-datetime start-name="begin_date" end-name="end_date" range></c-datetime>
				</c-form-item>
				<c-form-item label="预售类型" tip="选择【定金】则需要先支付一定比例的定金；【全款】类型则下单时，全款支付所有金额" required>
					<c-radio-group name="presell_type" v-model="presellType" :options="presellTypeOptions" :disabled="id!=null"></c-radio-group>
				</c-form-item>
				<c-form-item label="定金比例" v-if="presellType == 1" tip="填写30表示下单时，需要预先支付商品金额30%的定金" required>
					<c-input type="number" decimal="0" :range="[1,99]" v-model="prepaymentRatio" name="prepayment_ratio" unit="%" style="width:100px" ></c-input>
				</c-form-item>
				<c-form-item label="尾款时间" v-if="presellType == 1" tip="尾款必须在该时间段内完成支付，否则订单将被自动取消" required>
					<c-datetime start-name="balance_begin_date" end-name="balance_end_date" range></c-datetime>
				</c-form-item>
				<c-form-item label="活动标签">
					<c-input name="tags"  maxlength="4" placeholder="活动标签名称" ></c-input>
				</c-form-item>
				
				<c-title>活动商品</c-title>
				<c-form-item width="1100">
					<c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>

					<c-table ref="productList" :data="productList" height="auto" :paging="false" border style="width:1100px;" >
						<c-table-column
								type="selector"
						></c-table-column>

						<c-table-column
						  label="商品信息"
						  name="product_name"
						  width="250"
						>
							<template v-slot="{data}">
								<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
								<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
							</template>
						</c-table-column>

					  <c-table-column
						  label="商品货号"
						  name="product_itemnumber"
						  width="100"
					  ></c-table-column>

					  <c-table-column
								label="价格"
								name="product_price"
								width="130"
						>
							<template v-slot="{data}">￥{{data.product_price}}</template>
					  </c-table-column>

					  <c-table-column
						  label="折扣"
						  width="100"
					  >
						<template v-slot="{data}">
						  <c-input decimal="1" :range="[0.1,10]" v-model="data.activity_discount" width="80" type="number" style="margin: 0 5px;" unit="折"></c-input>
						</template>
					  </c-table-column>

					  <c-table-column
						  label="促销价"
						  name="promotion_price"
						  width="140"
					  >
						<template v-slot="{data}">
						  <span v-if="data.activity_discount" >
								  ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
								  <span v-if="data.product_price_max">
									  - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
								  </span>
								</span>
						</template>
					  </c-table-column>

					  <c-table-column
								type="button"
								fixed="right"
								label="操作"
								width="140"
						>
							<template v-slot="row">
								<c-table-button @click="deleteProduct(row.data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
            </c-form>

            <template slot="button">
				<c-button v-show="editFlag && auth('b_activity_presell_edit')" color="main" size="form" @click="submit()">确定提交</c-button>
            </template>
        </module>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
    import productSelector from '@/components/service/product_selector.vue'
    import Vue from "vue";
    export default {
        name: 'activity_presell_edit',

        components: {
            productInfo,productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                prepaymentRatio: 30,/*****定金比例 100表示100%定金***/
                presellType: 1,/**预售类型 1：允许先支付部分定金 2：必须支付全款**/
                presellTypeOptions: [
                  {name: '定金',value: 1},
                  {name: '全款',value: 2}
                ],
                activity_id: '',
                productList: [],
                editFlag: true
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            },

            commodityRange(val) {
                if (val == 2) {
                    this.$refs.productList.resize();
                }
            }
        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activityPresell/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        if(data.start_state == 1){
                            this.editFlag = false;
                        }
                        this.productList = data.product_list;
                    }
                });
            },
            productSelectHandle(list) {
              //添加初始值
              list.forEach(ll => {
                ll.activity_discount = 10;
              });

              list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
                });
                this.productList = this.productList.concat(list);
            },
			deleteProduct(rowData){
				const index = this.productList.indexOf(rowData);
				this.productList.splice(index, 1);
			},
            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/activityPresell/edit' : '/activityPresell/add',
                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
                        end_date: '请选择活动时间',
                        presell_type: '请选择预售类型',
                        prepayment_ratio_config: [{
                          type: 'function',
                          fun: (val,data) => {
                            //指定商品且设置折扣时判断
                            if(this.presellType == 1 && (!data.prepayment_ratio || data.prepayment_ratio<=0)){
                              return false;
                            }else return true;
                          },
                          message: '请设置定金比例'
                        }],
                        balance_date_config: [{
                          type: 'function',
                          fun: (val,data) => {
                            //指定商品且设置折扣时判断
                            if(this.presellType == 1 && !data.balance_start_date && !data.balance_end_date){
                                return false;
                            }else return true;
                          },
                          message: '请设置尾款时间'
                        }],
                        balance_date_compare: [{
                          type: 'function',
                          fun: (val,data) => {
                            //指定商品且设置折扣时判断
                            if(data.balance_end_date < data.begin_date){
                                return false;
                            }else return true;
                          },
                          message: '尾款结束时间必须设置在活动开始之后'
                        }],
                        product_list: [{
                            type: 'function',
                            fun: () => {
                                return this.productList.length;
                            },
                            message: '请选择活动商品'
                        }],
                        product_config: [{
                          type: 'function',
                          fun: () => {
                            //指定商品且设置折扣时判断
                            return !this.productList.find(item => {
                              return !item.activity_discount;
                            });
                          },
                          message: '请设置活动商品折扣'
                        }]
                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);

                        data.product_list = Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                activity_discount: parseFloat(item.activity_discount)
                            }
                        });
                        return data;
                    },

                    success: (data,obj) => {
                        if(obj != null && obj.length !=0){
                            var res = "【";
                            obj.forEach(item=>{
                                res+=item+","
                            })
                            res = res.substring(0,res.length-1);
                            res+="】"

                            this.$message({
								type:'success',
                                message: '保存成功,存在以下商品和其他活动时间冲突未能添加成功'+res.toString(),
                            });
                        }else{
                            this.$message({
								type:'success',
                                message: "保存成功",
                            });
                        }

                        this.navigateTo('/activity_presell');
                    }
                })
            }
        }
    }
</script>